/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
const { svg } = require('d3');
const d3 = require('d3')
const { setEcgConversionFactor } = require('../utils/converter');
const { TRANSLATE_GENERAL_TAG } = require('../consts');

let isFirstEcgPeack = true
let isFirstPpgPeack = true
const PEACK_LINE_COLOR = '#00C44E'
const AXIX_COLOR_5 = '#ccc'
const XAXIS_COLOR_25 = '#707070'
const PEACK_LINE_WIDTH = 2
const XAXIS_WIDTH_25 = 1
const DETAILED_GRAPH_LINE_COLOR = '#4349F9'
const GRAPH_LINE_COLOR = '#000'
const DETAILED_GRAPH_LINE_WIDTH = 2
const GRAPH_LINE_WIDTH = 1
const TRANSLATE_TAG = 'charts.ecg_ppg'

const getEcgNode = (rawData, width, height, isFirstEcg, isDetailedReport, fwVersion, translate) => {
  //in detailed report we have 256 mesurments per second
  const indexPerSecond = isDetailedReport ? 256 : 128
  const data = [];
  const scale = isDetailedReport ? 2 : 1
  const ecgCoversionFactor = setEcgConversionFactor(fwVersion)


  rawData.map((d, i) => {
    for (let index = 0; index < indexPerSecond; index++) {
      const getTime = (ind=index) => {
        return (ind + 1) / indexPerSecond + d.series
      }
      const value = isDetailedReport ? (+d.ecg[index]-10000) / 1000 : ((+d.ecg[index] - 10000) * ecgCoversionFactor);
      const obj = {
        time: getTime(),
        value: value,
      };
      if(isDetailedReport){
        if(d.ecgPeaks[index]) obj.line = 1;
        obj.peakType = d.ecgPeakTypes[index]
        obj.label = d.ecgHr[index];
        obj.lastLabel = d.ecgNextHr[index]
        if(obj.lastLabel) obj.lastLabel.sourceTime = (obj.lastLabel.sourceIndex + 1) / indexPerSecond + (d.series + 1)
      }
      data.push(obj);
    }
  });
  width = width || window.innerWidth - (window.innerWidth /15)
  height = height || 400;
  const xAxisRange = [rawData[0].series, rawData[0].series + 10];
  const seriesStarting = rawData[0].series;

  const margin = { top: 40, right: 30, bottom: 40, left: 50 };

  const x = d3
    .scaleLinear()
    .domain(xAxisRange)
    .range([margin.left, width - margin.right]); //[50, 1200-30]

  const y = d3
    .scaleLinear()
    .domain([-5, 5])
    .range([height - margin.bottom, margin.top]); // [450-40, 40 + 125]

  const xAxis = (g) =>
    g
      .attr('transform', `translate(0,${height - margin.bottom})`)
      .call(
        d3
          .axisBottom(x)
          .ticks(250)
          .tickPadding(10)
          .tickValues(
            Array(251)
              .fill(1)
              .map((e, i) => i / 25 + seriesStarting)
          )
          
          .tickFormat((d) => {
            return !isDetailedReport ? d : '';
          })
          .tickSize(!isDetailedReport ? 10 : 0)
          )
          .style('font-size', `${isDetailedReport ? 22 : 13}px`)
          .attr('color', isDetailedReport ? XAXIS_COLOR_25 : '#000')
          .attr('stroke-width', XAXIS_WIDTH_25)

      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('stroke-width', 1)
          .attr('color', isDetailedReport ? AXIX_COLOR_5 : 'red')
          .attr('class', 'line-grid')
          .attr('transform', `translate(0,${-height + margin.top + margin.bottom})`)
          .attr('y2', height - margin.top - margin.bottom)
      )
      .call((g) =>
        g
          .selectAll('.tick line:not(.line-grid)')
          .filter((e) => !Number.isInteger(e))
          .remove()
      )
      .call((g) => {
        g.selectAll('.tick text')
          .filter((e) => !Number.isInteger(e) || e === seriesStarting)
          .remove();
      })
      .call((g) => {
        g.selectAll('.tick text')
          .filter((e) => Number.isInteger(e))
          .attr('transform', `translate(${isDetailedReport ? -75 : -55},-10)`);
      })

      
      .call((g) =>
        g
          .selectAll('.line-grid')
          .filter((e, i) => {
            return i % 5 == 0;
          })
          .attr('stroke-opacity', '1')
      )

      .call((g) =>
        g
          .selectAll('.line-grid')
          .filter((e, i) => {
            return i % 25 == 0;
          })
          .attr('stroke-width', XAXIS_WIDTH_25)
          .attr('color', isDetailedReport ? XAXIS_COLOR_25 : 'red')
      )
      .call((g) => g.select('.domain').remove());
  const yAxis = (g) =>
    g
      .attr('transform', `translate(${margin.left},0)`)
      .call(
        d3
          .axisLeft(y)
          .ticks(50)
          .tickValues(
            Array(51)
              .fill(-5)
              .map((e, i) => e + 10 * (i / 50))
          )
          .tickSize(0)
          .tickPadding(1)
      )
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('class', 'line-grid')
          .attr('stroke-opacity', 0.2)
          .attr('color',  isDetailedReport ? AXIX_COLOR_5 : 'red')
          .attr('x2', width - margin.left - margin.right)
      )
      .call((g) =>
        g
          .selectAll('.line-grid')
          .filter((e, i) => {
            return i % 5 == 0;
          })
          .attr('stroke-opacity', '1')
      )
      .call((g) => {
        g.selectAll('.tick text').remove();
      })
      .call((g) => g.select('.domain').remove());

  const ecgLineGenerate = d3
    .line()
    .defined((d) => {
      return d.value > -5 && d.value < 5;
    })
    .x((d) => x(d.time))
    .y((d) => {
      return y(isDetailedReport ? d.value*2 : d.value); //for the correct praspactive
    });

  const svg = d3
    .create('svg')
    .attr('width', width)
    .attr('height', height);

    svg.append('g').call(yAxis);
    svg.append('g').call(xAxis);

    if(isDetailedReport){
      var borderPath = svg.append("rect")
        .attr("x", margin.left)
        .attr("y", margin.top)
        .attr("height", height - margin.top - margin.bottom)
        .attr("width", width - margin.left - margin.right)
        .style("stroke", isDetailedReport ? XAXIS_COLOR_25 : '#000')
        .style("fill", "none")
        .style("stroke-width", isDetailedReport ? XAXIS_WIDTH_25 : 1);


      let lastPeack = -5; //minus for hiding the first hr
      const labels = svg.append("g").selectAll("g")
        .data(data)
        .enter()
        .filter((d) => d.label)
        .append("g")
        .attr('transform', (d) => {
          let centerPeack = (d.time-lastPeack) / 2
          if(centerPeack > 1) centerPeack = 0.2 //for big spaces and first hr in row
          lastPeack = d.time
          let xPos = x(d.time-centerPeack)-15
          xPos = xPos < 40 ? -9999 : xPos//for hiding hr out of graph width
          return `translate(${xPos},150)`
        })

        labels.append('text')
        .attr('fill', "black")
        .text((d) => d.label);

        const lastLabelInRow = svg.append("g").selectAll("g")
        .data(data)
        .enter()
        .filter(d => d.lastLabel)
        .append("text")
        .attr('fill', "black")
        .attr('transform', (d) => {
          let xPos = x(d.time) + ((width - x(d.time)) / 2)-15
          return `translate(${xPos},150)`
        })
        .text((d) => {
          if(x(d.lastLabel.sourceTime-0.2)-width + margin.right + margin.left - 15 < 40) //check if this label will display at the begining of the next chart
            return d.lastLabel.ecgHr
        });

        const bubble = labels.append('g')
        .filter(d => {
          if(isFirstEcgPeack){
            isFirstEcgPeack = false
            return d
          }
        })

      const bubbleRect  = bubble.append("rect")
        .attr('transform', `translate(-48,-70)`)
        .attr("width", 120)
        .attr("height", 30)
        .attr("rx", 15)
        .style("fill","#012f5f")
      
      const bubbleArrow = bubble.append("rect")
        .attr('transform', `translate(-3,-45)rotate(-45)`)
        .attr("width", 20)
        .attr("height", 20)
        .style("fill","#012f5f")

      bubble.append('text')
        .attr('fill', "black")
        .attr('transform', `translate(10,-50)`)
        .attr('text-anchor', 'middle')
        .text((d) => {
            isFirstEcgPeack = false
            return translate ? translate(`${TRANSLATE_TAG}.bubbels.hr`) : 'Heart Rate'
        })
        .style("fill", "#fff");
  
        var horizionalLine = svg.append("g").selectAll("g")
          .data(data)
          .enter()
          .filter((d) => d.line)
          .append("line")
          .attr('x1', (d)=> x(d.time))
          .attr( 'y1', (d)=> y(d.value*2))
          .attr('x2', (d)=> x(d.time))
          .attr('y2', (d)=> y(d.value*2)+1000)
          .style("stroke", PEACK_LINE_COLOR)
          .style("stroke-width", PEACK_LINE_WIDTH);
  
        var ecgPeakTypes = svg.append("g").selectAll("g")
          .data(data)
          .enter()
          .filter(d => d.peakType)
          .append("text")
          .attr('fill', (d) => d.peakType === 'N' ? 'black' : 'red')
          .attr('transform', (d) => {
            return `translate(${x(d.time)-5},65)`
          })
          .style('font-size', 23)
          .text((d) => translate ? translate(`${TRANSLATE_TAG}.legends.${d.peakType.toLowerCase()}.key`) : d.peakType)
      }

  const ecgLine = svg
    .append('path')
    .attr('d', ecgLineGenerate(data))
    .attr('fill', 'none')
    .attr('stroke', isDetailedReport ? DETAILED_GRAPH_LINE_COLOR : GRAPH_LINE_COLOR)
        .attr('stroke-width', isDetailedReport ? DETAILED_GRAPH_LINE_WIDTH : GRAPH_LINE_WIDTH);

  

  const yAxisLabelDate = svg
    .append('text')
    .attr('x', margin.left)
    .attr('y', margin.top - 20)
    .style('font-size', `${isDetailedReport ? 20 : 12}px`)
    .attr('font-weight', '400')
    .text(translate ? translate(`${TRANSLATE_TAG}.lead_ecg`) : 'Lead I ECG');

    if(!isDetailedReport){
      const xAxisLabelDay = svg
          .append('text')
          .attr('x', 47)
          .attr('y', height - margin.bottom + 31)
          .style('font-size', `${isDetailedReport ? 20 : 12}px`)
          .attr('font-weight', '400')
          .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.general_words.sec`) : 'sec');
    }
  
  const g = svg
    .append('g')
    .selectAll('g')
    .data(data)
    .join('g')
    .attr('transform', (d) => `translate(${x(d.time) + 11},0)`);

  return svg.node();
};
const getPpgNode = (rawData, width, height, isDetailedReport, translate) => {
  const indexPerSecond = isDetailedReport ? 256 : 64
  const data = [];
  rawData.map((d) => {
    for (let index = 0; index < indexPerSecond; index++) {
      //in case of detailed report the structure is 256 per second but we should take just every forth and the other three will be the same
      const forCleanLine = isDetailedReport ? index%4 : 0
      const obj = {
        time: ((index-forCleanLine) + 1) / indexPerSecond + d.series,
        value: (+d.ppg[index-forCleanLine]),
      };
      if(isDetailedReport){
        if(d.ppgPeaks[index]) obj.line = +d.ppg[index];
        obj.original_time = (index + 1) / indexPerSecond + d.series,
        obj.label = d.ppgHr[index];
        obj.percent = d.ppgHrPercent[index];
        obj.lastLabel = d.ppgNextHr[index]
        if(obj.lastLabel) obj.lastLabel.sourceTime = ((obj.lastLabel.sourceIndex-forCleanLine) + 1) / indexPerSecond + (d.series + 1)
      }
      data.push(obj);
    }
  });
  width = width || window.innerWidth - (window.innerWidth /15)
  height = height || 400;
  const xAxisRange = [rawData[0].series, rawData[0].series + 10];
  const seriesStarting = rawData[0].series;

  const margin = { top: 40, right: 30, bottom: 40, left: 50 };

  const x = d3
    .scaleLinear()
    .domain(xAxisRange)
    .range([margin.left, width - margin.right]); //[50, 1200-30]

  const minVal = d3.min(data, (d) => {
    return d.value ? isDetailedReport ? d.value-15 : d.value : null;
  });
  const maxVal = d3.max(data, (d) => isDetailedReport ? d.value+15 : d.value);//in detailed report for not starting the line from the base chart

  const y = d3
    .scaleLinear()
    .domain([minVal, maxVal])
    .range([height - margin.top, margin.bottom]); // [450-40, 40 + 125]

  const xAxis = (g) =>
  g
    .attr('transform', `translate(0,${height - margin.bottom})`)
    .call(
      d3
        .axisBottom(x)
        .ticks(10)
        .tickPadding(10)
        .tickValues(
          Array(11)
            .fill(1)
            .map((e, i) => i + seriesStarting)
        )
        .tickSize(10)
        )
        .attr('stroke-width', 1)
        .style('font-size', `${isDetailedReport ? 20 : 12}px`)
        .attr('color', isDetailedReport ? XAXIS_COLOR_25 : '#000')


    .call((g) => {
      g.selectAll('.tick text')
        .filter((e) => {
          return !Number.isInteger(e) || e === seriesStarting;
        })
        .remove();
    })
    .call((g) => {
      g.selectAll('.tick text')
        .filter((e) => Number.isInteger(e))
        .attr('transform', `translate(${isDetailedReport ? -75 : -55},-10)`);
      })
    .call((g) => g.select('.domain').remove());

  const yAxis = (g) =>
    g
      .attr('transform', `translate(${margin.left},0)`)
      .call(
        d3
          .axisLeft(y)
          .ticks(6)
          .tickValues(
            Array(6)
              .fill(1)
              .map((e, i) => minVal + (i * (maxVal - minVal)) / 5)
          )
          .tickSize(0)
          .tickPadding(1)
      )
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('class', 'line-grid')
          .attr('stroke-opacity', 0.3 )
          .attr('stroke-width', 1 )
          .attr('color', isDetailedReport ? XAXIS_COLOR_25 : '#000')
          .attr('x2', width - margin.left - margin.right)
      )
      .call((g) => {
        g.selectAll('.tick text').remove();
      })
      .call((g) => g.select('.domain').remove());
      

  const ppgLineGenerate = d3
    .line()
    .curve(d3.curveBasis)
    .defined((d) => {
      return d.value > 0;
    })
    .x((d) => x(d.time))
    .y((d) => y(d.value));

  const svg = d3
    .create('svg')
    .attr('width', width)
    .attr('height', height);

    svg.append('g').call(xAxis);

    var borderPath = svg.append("rect")
    .attr("x", margin.left)
    .attr("y", margin.top)
    .attr("height", height - margin.top - margin.bottom)
    .attr("width", width - margin.left - margin.right)
    .style("stroke", isDetailedReport ? XAXIS_COLOR_25 : '#000')
    .style("fill", "none")
    .style("stroke-width", isDetailedReport ? XAXIS_WIDTH_25 : 1);

    const ppgLine = svg
        .append('path')
        .attr('d', ppgLineGenerate(data))
        .attr('fill', 'none')
        .attr('stroke', isDetailedReport ? DETAILED_GRAPH_LINE_COLOR : GRAPH_LINE_COLOR)
        .attr('stroke-width', isDetailedReport ? DETAILED_GRAPH_LINE_WIDTH : GRAPH_LINE_WIDTH);

    svg.append('g').call(yAxis);

    const xAxisLabelDay = svg
    .append('text')
    .attr('x', 47)
    .attr('y', height - margin.bottom + 31)
    .style('font-size', `${isDetailedReport ? 20 : 12}px`)
    .attr('font-weight', '400')
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.general_words.sec`) : 'sec');

    if(isDetailedReport){
      var horizionalLine = svg.append("g").selectAll("g")
      .data(data)
      .enter()
      .filter((d) => d.line)
      .append("line")
      .attr('x1', (d)=> x(d.original_time))
      .attr( 'y1', (d)=> y(d.line))
      .attr('x2', (d)=> x(d.original_time))
      .attr('y2', (d)=> y(d.value)-1000)
      .style("stroke", PEACK_LINE_COLOR)
      .style("stroke-width", PEACK_LINE_WIDTH);

      
      let lastPeack = null
      const labels = svg.append("g").selectAll("text")
        .data(data)
        .enter()
        .filter((d) => d.label)
        
        const labelPlace = labels.append('g')
        .attr('transform', (d) => {
          let centerPeack = (d.time-lastPeack) / 2
          if(centerPeack > 1 || !lastPeack) centerPeack = 0.2 //for big spaces and first hr in row
          // if(!lastPeack) centerPeack = 10000//to hide the first hr
          lastPeack = d.time
          let xPos = x(d.time-centerPeack)-15
          xPos = xPos < 40 ? -9999 : xPos//for hiding hr out of graph width
          return `translate(${xPos},320)`
        })

        labelPlace.append('text')
        .attr('fill', "black")
        .text((d) => d.label);

        const bubble = labelPlace.append('g')
        .filter(d => {
          let xPos = x(d.time-0.2)-15
          if(isFirstPpgPeack && xPos > 40){
            isFirstPpgPeack = false
            return d
          }
        })

      const bubbleRect  = bubble.append("rect")
        .attr('transform', `translate(-48,-65)`)
        .attr("width", 120)
        .attr("height", 30)
        .attr("rx", 15)
        .style("fill","#012f5f")
      
      const bubbleArrow = bubble.append("rect")
        .attr('transform', `translate(-3,-40)rotate(-45)`)
        .attr("width", 20)
        .attr("height", 20)
        .style("fill","#012f5f")

      bubble.append('text')
        .attr('fill', "black")
        .attr('transform', `translate(10,-45)`)
        .attr('text-anchor', 'middle')
        .text(translate ? translate(`${TRANSLATE_TAG}.bubbels.pr`) : 'Pulse Rate')
        .style("fill", "#fff");

      const bubblePercentRect  = bubble.append("rect")
        .attr('transform', `translate(-48,50)`)
        .attr("width", 120)
        .attr("height", 30)
        .attr("rx", 15)
        .style("fill","#012f5f")
      
      const bubblePersentArrow = bubble.append("rect")
        .attr('transform', `translate(-3,55)rotate(-45)`)
        .attr("width", 20)
        .attr("height", 20)
        .style("fill","#012f5f")

      bubble.append('text')
        .attr('fill', "black")
        .attr('transform', `translate(10,70)`)
        .attr('text-anchor', 'middle')
        .attr('class', 'first-rpv')
        .text(translate ? translate(`${TRANSLATE_TAG}.bubbels.rpv`) : 'RPV')
        .style("fill", "#fff");

      labelPlace.append('text')
        .attr('transform', 'translate(0,30)')
        .attr('fill', "black")
        .text((d) => `${d.percent}%`);

        const lastLabelInRowPlace = svg.append("g").selectAll("text")
        .data(data)
        .enter()
        .filter(d => d.lastLabel && (x(d.lastLabel.sourceTime-0.2)-width + margin.right + margin.left - 15 < 40)) //check if this label will display at the begining of the next chart)
        .append("g")
        .attr('fill', "black")
        .attr('transform', (d) => {
          let xPos = x(d.time) + ((width - x(d.time)) / 2)-15
          return `translate(${xPos},320)`
        })

        lastLabelInRowPlace.append('text')
        .text((d) => d.lastLabel.ppgHr);

        lastLabelInRowPlace.append('text')
        .attr('transform', 'translate(0,30)')
        .text((d) => `${d.lastLabel.ppgHrPercent}%`);

    }

  const yAxisLabelDate = svg
    .append('text')
    .attr('x', margin.left)
    .attr('y', margin.top - 20)
    .style('font-size', `${isDetailedReport ? 20 : 12}px`)
    .attr('font-weight', '400')
    .text(translate ? translate(`${TRANSLATE_TAG}.ppg`) : 'PPG');


  const g = svg
    .append('g')
    .selectAll('g')
    .data(data)
    .join('g')
    .attr('transform', (d) => `translate(${x(d.time) + 11},0)`);

  return svg.node();
};

exports.appendEcgChart = (rawData,thresholds,onClick,width,height,isDetailedReport, fwVersion, translate)=> {
   const ecg_ppg = rawData.ecg_ppg.ecg_ppg_strips_sorted
let arr = []
  for (let index = 0; index < ecg_ppg?.length; index++) {
    const { container, type, strips } = ecg_ppg[index];
    let node;
    if (type === 'ecg' && strips ) {
      const isFirstEcg = index === 0
      node = getEcgNode(strips, width, height, isFirstEcg, isDetailedReport, fwVersion, translate);
      arr.push(node)
      document.querySelector(`#${container}`)?.append(node);
    } else if (type === 'ppg' && strips ) {
      node =getPpgNode(strips, width, height, isDetailedReport, translate);
      arr.push(node)
     document.querySelector(`#${container}`)?.append(node);
    }
    arr.push(svg)
  }

  return arr 
};
